<template>
  <div class="container" style="padding-top: 100px; padding-bottom: 100px;">
    <div v-html="content"></div>
  </div>
</template>

<script>
import _ from "lodash";

export default {
  name: "InfoPage",
  data() {
    return {
      content: ""
    };
  },
  async mounted() {
    this.$store.commit("showSpinner");
    let response = await this.$http.get(
      "/api/v1/campaigns/" +
        this.$store.state.campaign.id +
        "/info/" +
        this.$route.params.page
    );
    this.content = _.get(response, "data.data.info", this.$route.params.page);
    this.$store.commit("hideSpinner");
  }
};
</script>

<style></style>
